import Container from "../../components/Container";
import Button from "../../components/Button";
import { Link } from "react-router-dom";
import styles from "../order/index.module.scss";
import { Helmet } from "react-helmet-async";

export default function OrderPage() {
    return (
        <>
            <Helmet>
                <title>在庫エラー | 西部ガス</title>
                <meta
                    name="description"
                    content="商品が完売しました。ご希望の商品が完売したため、決済は行われておりません。申し訳ございませんが別の商品をご検討・ご注文いただきますようお願いいたします。"
                />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            
            <div className={styles.orderPage} >
                <section className={styles.orderPage__errorSection} >
                    <Container style={{ height: "60rem" }}>
                        <p
                            style={{
                                fontSize: "3.2rem",
                                textAlign: "center",
                            }}
                            className="noto-sans-jp-bold"
                        >
                            商品が完売しました。
                        </p>
                        <p
                            style={{
                                fontSize: "2rem",
                                lineHeight: "1.8",
                                margin: "4rem 3rem 6rem",
                                textAlign: "center",
                            }}
                            className="noto-sans-jp-medium"
                        >
                            ご希望の商品が完売したため、決済は行われておりません。
                            <br />
                            申し訳ございませんが別の商品をご検討・ご注文いただきますようお願いいたします。
                        </p>
                        <div>
                            <Button
                                variant="white"
                                className="noto-sans-jp-bold"
                            >
                                <Link
                                    to="/pr_tableconro"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <span>テーブルコンロ</span>
                                    <span>専用サイトに戻る</span>
                                </Link>
                            </Button>
                            <Button
                                variant="white"
                                className="noto-sans-jp-bold"
                            >
                                <Link
                                    to="/pr_fh"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <span>ガスファンヒーター</span>
                                    <span>専用サイトに戻る</span>
                                </Link>
                            </Button>
                        </div>
                    </Container>
                </section>
            </div>
        </>
    );
}
